import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { NzModalModule } from 'ng-zorro-antd/modal'

@Component({
  selector: 'aiomed-system-status-modal',
  imports: [NzModalModule],
  templateUrl: './system-status-modal.component.html',
  styleUrl: './system-status-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SystemStatusModalComponent {
  readonly isVisible = input.required<boolean>()
}
